export default __webpack_public_path__ + "static/media/photo--sm--92.a8284879.jpg";